export default {
    data: () => ({
        translations: {
            online: {
                el: "Ενεργό",
                en: "Active",
                it: "Attivo"
            },
            offline: {
                el: "Ανενεργό",
                en: "Inactive",
                it: "Inattivo"
            },
            transactions: {
                el: "Συναλλαγές",
                en: "Transactions",
                it: "Transazione"
            },
            total: {
                el: "Τζίρος",
                en: "Revenue",
                it: "Totale"
            },
            clients: {
                el: "Πελάτες",
                en: "Clients",
                it: "Customers",
            },
            views: {
                el: "Προβολές",
                en: "User views",
                it: "Visualizzazioni utenti",
            },
            loyaltyRetention:{
                el: "Πιστοί Πελάτες",
                en: "Loyalty Retention",
                it: "Clienti Fedeli",
            },
            customerRetention:{
                el: "Διατήρηση Πελατών",
                en: "Customer Retention",
                it: "Ritenzione del Cliente",
            },
            clicks: {
                el: "Clicks",
                en: "Clicks",
                it: "Clicks",
            },
            repeatPurchase: {
                el: "Επαναλαμβανόμενες Αγορές",
                en: "Repeat Purchase",
                it: "Ripetere l'Acquisto",
            },
            payments: {
                el: "Πληρωμές",
                en: "Payments",
                it: "Pagamenti",
            },
            averageBasket: {
                el: "Μέσο Καλάθι",
                en: "Average Basket",
                it: "Cestino Medio",
            },
            mapViews: {
                el: "Πλοηγήσεις",
                en: "Map views",
                it: "Navigazione",
            },
            last12h:{
                el: "Τελευταίο 12ωρο",
                en: "Last 12 Hours",
                it: "Ultime 12Ore",
            },
            last7d:{
                el: "Τελευταίες 7 ημέρες",
                en: "Last 7 days",
                it: "Ultimi 7 giorni",
            },
        }
    })
};
